/**
 * Reine Hilfsfunktion: prüft, ob eine aktuelle Route zu einem
 * `DebugRouteMatcher` passt.
 *
 * Ohne Matcher → `true` (Backwards-Compat für globale Einträge wie
 * Error-Boundary-Reports).
 */
import type { DebugRouteMatcher } from './types';

export function matchesDebugRoute(
  pathname: string,
  matcher: DebugRouteMatcher | undefined,
): boolean {
  if (!matcher) return true;
  if (matcher.routes && matcher.routes.some((r) => r === pathname)) return true;
  if (
    matcher.routePrefixes &&
    matcher.routePrefixes.some((p) => pathname === p || pathname.startsWith(p))
  ) {
    return true;
  }
  if (matcher.routePattern && matcher.routePattern.test(pathname)) return true;
  return false;
}